import { useEffect } from 'react';
import styled from 'styled-components';
import { isMobile } from '../../../../core';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    !props.isFullScreen &&
    `
    position: absolute;
    top: 50px;
    right: 50px;
  `}

  ${(props) =>
    props.isFullScreen &&
    `
    width: 100%;
    height: 100%;
  `}

  ${(props) =>
    !props.isFullScreen &&
    !props.isMobile &&
    `
    width: 200px;
    height: 112px;
  `}

  ${(props) =>
    !props.isFullScreen &&
    props.isMobile &&
    `
    width: 20%;
  `}

  ${(props) =>
    !props.isActive &&
    `
    display: none;
  `}
`;

const VideoEl = styled.video`
  width: 100%;
  height: 100%;
`;

let timer;
const LocalVideo = ({ stream, isFullScreen, isActive }) => {
  useEffect(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const videoEL = document.getElementById(`local-video`);

      videoEL.srcObject = stream;
      videoEL.setAttribute('playsinline', true);
      videoEL.setAttribute('autoplay', true);
      videoEL.setAttribute('muted', true);
      videoEL.play();
    }, 1000);
  }, [stream]);

  return (
    <Wrapper id="wrapper" isFullScreen={isFullScreen} isActive={isActive} isMobile={isMobile}>
      <VideoEl id="local-video" autoplay muted={true} playsinline />
    </Wrapper>
  );
};

export default LocalVideo;
